import React from 'react';
import { Wrapper, Heading, Content, TopIcon, Tnc } from './styles';

const Popup1 = () => (
  <Wrapper>
    <TopIcon>
      <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/icon3.png`} alt="" width="100" />
    </TopIcon>
    <Heading>錄音室原音母帶</Heading>
    <br />
    <hr />
    <Content>
    MOOV 為香港唯一及首個提供錄音室原音母帶之音樂串流平台<sup>*</sup>，為你帶來只有唱片監製、歌手及製作人員才有機會接觸到的錄音室原音母帶，為你帶來錄音室級聽覺體驗。
    <br />
    <br />
極度罕有的錄音室原音母帶展現歌曲錄製後的最初形態，音場遼闊，還原錄音室內的環境狀況，讓你追溯音樂本源，完美感受歌手和樂手們錄音時的力度表現及情感流動，以及監製在錄音室內所製作最原本的聲音。
    <br />
    <br />
    配合MOOV 24 bit FLAC 無損串流及下載服務，讓你彈指間輕鬆穿梭歌手們的錄音室現場。
    <br />
    <br />
    <Tnc>*根據MOOV針對在香港營運之8大音樂串流平台之內部調查。截至2020年3月16日，MOOV是香港首個及唯一音樂串流平台在流動應用程式內提供24 bit FLAC無損音樂，當中包括錄音室原音母帶版本及升頻版本的內容。</Tnc>
    </Content>
  </Wrapper>
)

export default Popup1;